import React from "react";
import { useLocation } from "react-router-dom";
import Banner from "./Banner";
import ContactSection from "./ContactSection";
import LinksSection from "./LinksSection";
import AboutMe from "./AboutMe";

const backgrounds = ["#111111", "#f2f2f2"]; // black, grey

const Home = () => {
  const contactRef = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.scrollTo === "contact" && contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
    // Clean up state after handling
    // eslint-disable-next-line
  }, [location.state]);

  const sections = [
    <Banner key="banner" />,
    <AboutMe key="about" />,
    <LinksSection key="links" />,
    <div key="contact" ref={contactRef} id="contact-section">
      <ContactSection />
    </div>,
  ];

  return (
    <div>
      {sections.map((Section, idx) => (
        <div key={idx} style={{ background: backgrounds[idx % backgrounds.length] }}>
          {Section}
        </div>
      ))}
    </div>
  );
};

export default Home; 